import { Component, OnInit, Input, EventEmitter, Output, HostBinding } from '@angular/core';

@Component({
  selector: 'text-toggle',
  templateUrl: './text-toggle.component.html',
  styleUrls: ['./text-toggle.component.scss']
})
export class TextToggleComponent implements OnInit {
  @HostBinding('style.border-color') styleBorderColor = this.borderColor;

  disabledValue = false;

  @Input() set disabled(value: boolean) {
    this.disabledValue = value;
    this.styleBorderColor = this.borderColor;
  }

  get disabled() {
    return this.disabledValue;
  }

  @Output() modelChange: EventEmitter<any> = new EventEmitter();

  modelValue: any;

  @Input() get model(): any {
    return this.modelValue;
  }

  set model(value: any) {
    this.modelValue = value;
    this.modelChange.emit(this.modelValue);
  }

  get borderColor() {
    return this.disabled ? '#a8d6fa' : '#2096F3';
  }

  get leftSelection(): boolean {
    return this.model.left.status;
  }

  get rightSelection(): boolean {
    return this.model.right.status;
  }

  get left() {
    return this.model.left.value;
  }

  get right() {
    return this.model.right.value;
  }

  constructor() { }

  ngOnInit() {
  }

  toggle(side: string) {
    if (this.disabled) { return; }

    if (side === 'left') {
      this.model = {
        left: { value: this.model.left.value, status: true},
        right: { value: this.model.right.value, status: false}
      };
    } else {
      this.model = {
        left: { value: this.model.left.value, status: false},
        right: { value: this.model.right.value, status: true}
      };
    }
  }
}
